import KWeatherDialog from "kinnect-front/KYard/Schedule/KWeatherDialog";
import {
	VBadge,
	VCard,
	VCol,
	VIcon,
	VImg
} from "vuetify/lib";

export default {
	name: "KWeatherCell",

	props: { schedule: Object },

	computed: {
		genCardContent() {
			const content = [
				this.schedule.weather.icon && <VCol class="pa-1 text-center">
					<VImg
						class="mx-auto"
						maxWidth={40}
						src={require( `@/assets/icons/weather/${this.schedule.weather.icon}.png` )}
					></VImg>
				</VCol>,

				<VCol class="pa-1 text-no-wrap text-center">
					{Math.round( this.schedule.weather.temperatureLow )}&deg; to {Math.round( this.schedule.weather.temperatureHigh )}&deg;
					<br/>
					{Math.round( this.schedule.weather.precipProbability )}% precip.
				</VCol>
			];

			return this.schedule.weather.hasAlerts
				? <VBadge
					color="error"
					overlap
				>
					{this.schedule.weather.hasAlerts && <VIcon
						dark
						slot="badge"
					>warning</VIcon>}

					{content}
				</VBadge>
				: content;
		}
	},

	render() {
		if ( !this.schedule.weather ) {
			return <div class="text-subtitle-1 text-center">N/A</div>;
		}

		return <KWeatherDialog
			schedule={this.schedule}
			scopedSlots={{
				activator: ( { on } ) =>
					<VCard
						class="my-1 text-center"
						on={on}
						outlined
						style="position: relative;"
					>
						{this.genCardContent}
					</VCard>
			}}
		></KWeatherDialog>;
	}
};
